import { MixedColour } from 'CommonData/poco/index';

export class MixedColourMapper {
    public static map(data: any, colourMixSetId: number): Array<MixedColour> {
        if (!data) {
            throw 'No data for mapper: MixedColourMapper';
        }

        if (!colourMixSetId) {
            return null;
        }

        const matchingMixedColourSet = data.colourMixedSets.find((cms: any) => cms.id == colourMixSetId);
        if (!matchingMixedColourSet) {
            return null;
        }

        return matchingMixedColourSet.materialTextures.map((mt: any) => 
            new MixedColour({
                textureKey: mt.key,
                name: mt.name,
                swatchImageUrl: mt.swatchImageUrl
            })
        );
    }
} 